import React, { useEffect, useState } from "react";
import { Navigate, useLocation } from "react-router-dom";
import { useAuth } from "./Auth";
import { requiresPhoneUpdate } from "./phoneRequirement";
import WordQuestLoadingScreen from "../features/wordQuest/WordQuestLoadingScreen";
import { canAccessExam, getAllowedExam } from './examAccess';

const ProtectedRoute = ({ children, allowIncompleteContact = false, exam }) => {
  const { isAuthenticated, isUserHydrated, user } = useAuth();
  const [isLoading, setIsLoading] = useState(true);
  const location = useLocation();

  useEffect(() => {
    const checkAuth = async () => {
      setIsLoading(false);
    };

    checkAuth();
  }, [location.pathname]);

  if (isLoading || !isUserHydrated) {
    return location.pathname.startsWith("/word-quest")
      ? <WordQuestLoadingScreen />
      : <div></div>;
  }

  if (!isAuthenticated) {
    return <Navigate to="/login" state={{ from: location }} replace />;
  }

  if (!allowIncompleteContact && requiresPhoneUpdate(user)) {
    return (
      <Navigate
        to="/complete-profile"
        state={{ from: location }}
        replace
      />
    );
  }

  if (exam && !canAccessExam(user, exam)) {
    return <Navigate replace to={`/${getAllowedExam(user)}-dashboard`} />;
  }

  return children;
};

export default ProtectedRoute;
